import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, ButtonGroup, Button } from 'react-bootstrap'
import WithAuth from '../../HOCs/WithAuth'

import LoadingScreen from '../../components/LoadingScreen'

import Notifications from './components/Notifications'
import NotificationMessage from './components/NotificationMessage'

import {
  getNotifications,
  setCurrentNotification,
  togglePinNotification,
  markAllNotificationsAsRead,
  deleteUnpinnedNotifications,
  deleteNotification,
 } from './reducers/notificationsReducer'

import './style.css'


class NotificationsContainer extends Component {

  componentDidMount() {
    this.props.getNotifications(this.props)
  }

  readAllNotifications = () => this.props.markAllNotificationsAsRead(this.props)

  removeUnpinnedNotifications = () => this.props.deleteUnpinnedNotifications(this.props)

  render() {
    if (this.props.fetchingNotification) {
      return <LoadingScreen text="Loading" />
    }

    return (
      <div className='ChartsContainer'>
        <Row>
          <Col xs={5} sm={6} md={6} lg={8}>
            <span style={{fontSize: '2em'}}>
              Notifications
            </span>
          </Col>

          <Col xs={7} sm={6} md={6} lg={4}>
            <ButtonGroup>
              <Button
                variant='outline-primary'
                onClick={this.readAllNotifications}
              >
                Mark all as read
              </Button>

              <Button
                variant='outline-danger'
                onClick={this.removeUnpinnedNotifications}
              >
                Delete unpinned
              </Button>
            </ButtonGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={6} sm={6} md={5} lg={5}>
            <Notifications {...this.props} />
          </Col>

          <Col xs={6} sm={6} md={7} lg={7}>
            {this.props.currentNotification ?
              <NotificationMessage {...this.props} />
              :
              null
            }
          </Col>
        </Row>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    fetchingNotification: state.notificationsReducer.fetchingNotification,
    notifications: state.notificationsReducer.notifications,
    unreadNotifications: state.notificationsReducer.unreadNotifications,
    currentNotification: state.notificationsReducer.currentNotification,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNotifications: (props) => dispatch(getNotifications(props)),

    setCurrentNotification: (notification, props) => {
      return dispatch(setCurrentNotification(notification, props))
    },

    togglePinNotification: (notification, pinned, props) => {
      return dispatch(togglePinNotification(notification, pinned, props))
    },

    markAllNotificationsAsRead: (props) => dispatch(markAllNotificationsAsRead(props)),

    deleteUnpinnedNotifications: (props) => dispatch(deleteUnpinnedNotifications(props)),

    deleteNotification: (notification, props) => {
      return dispatch(deleteNotification(notification, props))
    },
  }
}

export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer))
